import { MEDIA } from './assets.js';

// These are optical object bounds in the original sheets. The generated
// traffic sheets do not line up with their advertised four-column grid: the
// next skiff starts inside the canoe's nominal cell. Clip actual source pixels
// rather than scaling the sheet until a neighboring object enters the frame.
const source = (url, width, height, rect, contactY) => Object.freeze({
  url, sheetWidth: width, sheetHeight: height,
  x: rect[0], y: rect[1], width: rect[2], height: rect[3],
  contactY: contactY ?? rect[1] + rect[3],
});
const river = (rect, contactY) => source(MEDIA.vessels, 1536, 1024, rect, contactY);
const road = (rect, contactY) => source(MEDIA.road, 1536, 1024, rect, contactY);
const building = (rect, contactY) => source(MEDIA.facilities, 1536, 1024, rect, contactY);

export const SCENE_BACKDROP = './media/v2/riverfront-diorama.png';

export const RIVER_ART = Object.freeze({
  'trapper-canoe': river([18, 132, 293, 116], 232),
  'fishing-skiff': river([345, 139, 359, 115], 239),
  'log-raft': river([721, 111, 366, 147], 242),
  flatboat: river([1096, 118, 438, 145], 241),
  keelboat: river([0, 287, 411, 326], 593),
  'survey-cutter': river([782, 318, 309, 302], 594),
  'freight-barge': river([1097, 469, 437, 161], 610),
  'packet-steamer': river([0, 654, 373, 294], 927),
  'luxury-steamer': river([379, 659, 381, 288], 930),
  showboat: river([777, 654, 406, 295], 933),
  'gaming-steamer': river([777, 654, 406, 295], 933),
});

export const ROAD_ART = Object.freeze({
  'trapper-walker': road([60, 32, 247, 302], 321),
  'unhoused-traveler': road([712, 37, 380, 301], 325),
  'settler-wagon': road([665, 376, 460, 273], 635),
  peddler: road([351, 423, 313, 231], 640),
  caravan: road([1136, 708, 394, 279], 963),
  stagecoach: road([11, 700, 427, 280], 952),
  drovers: road([855, 704, 276, 279], 961),
  'survey-crew': road([1154, 56, 375, 282], 325),
  'mail-coach': road([440, 703, 410, 280], 953),
  'tour-party': road([15, 351, 334, 306], 639),
  'new-york-travelers': road([712, 37, 380, 301], 325),
  'california-prospectors': road([60, 32, 247, 302], 321),
});

export const BUILDING_ART = Object.freeze([
  building([29, 65, 354, 264], 318),
  building([413, 58, 343, 272], 318),
  building([796, 39, 341, 293], 321),
  building([1168, 146, 351, 188], 324),
  building([31, 389, 350, 269], 643),
  building([399, 394, 358, 264], 646),
  building([771, 416, 368, 242], 645),
  building([1159, 419, 348, 243], 648),
  building([14, 704, 369, 258], 950),
  building([425, 687, 317, 280], 950),
  building([803, 692, 302, 276], 951),
  building([1140, 699, 368, 266], 951),
]);

export function atlasSource(url, sheetWidth, sheetHeight, frame, columns, rows) {
  const width = sheetWidth / columns, height = sheetHeight / rows;
  return source(url, sheetWidth, sheetHeight, [
    (frame % columns) * width, Math.floor(frame / columns) * height, width, height,
  ]);
}

export function sourceAspect(art) { return art.width / art.height; }

// A tightly bounded SVG viewport is a renderer, not a new bitmap. Explicit
// image dimensions and preserveAspectRatio keep source pixels undistorted.
export function sourceViewport(art) {
  return `${art.x} ${art.y} ${art.width} ${art.height}`;
}
